import React from 'react';
export function PricingCards() {
  return <section id="pricing-section" className="py-12" data-id="element-286">
      <div className="max-w-4xl mx-auto" data-id="element-287">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 mb-10" data-id="element-288">
          Try Aya Caps Today & Experience The Healing For Yourself
        </h2>
        <p className="text-xl text-center mb-8" data-id="element-289">
          All orders come with a 30-day money-back guarantee. Free shipping on 3
          bottles or more.
        </p>
        <div className="flex flex-row gap-2 md:gap-4 overflow-x-auto pb-4" data-id="element-290">
          {/* Best Value Card */}
          <div className="flex-1 min-w-[120px] md:min-w-[280px] bg-gradient-to-b from-white to-green-50 rounded-xl shadow-xl border border-green-200 overflow-hidden transition-transform duration-300 hover:shadow-2xl hover:-translate-y-1" data-id="element-291">
            <div className="bg-emerald-600 text-white text-center py-2 md:py-3 font-bold text-sm md:text-lg" data-id="element-292">
              BEST VALUE
            </div>
            <div className="p-3 md:p-6" data-id="element-293">
              <h3 className="text-lg md:text-2xl font-bold text-center mb-1 md:mb-2" data-id="element-294">
                Buy 3, Get 3 Free
              </h3>
              <p className="text-sm md:text-lg text-center text-gray-600 mb-2 md:mb-6" data-id="element-295">
                6-Month Supply
              </p>
              <div className="flex justify-center mb-2 md:mb-6" data-id="element-296">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uDb9VXcjYWDRgpHNDM24Xy/Untitled_design_87.png" alt="6 bottles of Aya Caps" className="w-full max-w-[100px] md:max-w-[200px] h-auto" data-id="element-297" />
              </div>
              <div className="text-center mb-2 md:mb-6" data-id="element-298">
                <div className="flex justify-center items-center gap-1 md:gap-2 mb-0 md:mb-1" data-id="element-299">
                  <span className="text-sm md:text-xl line-through text-gray-500" data-id="element-300">
                    $294
                  </span>
                  <span className="text-xl md:text-3xl font-bold text-emerald-700" data-id="element-301">
                    $147
                  </span>
                </div>
                <p className="text-xs md:text-lg text-emerald-600 font-semibold" data-id="element-302">
                  Save 50% ($24.50/bottle)
                </p>
                <p className="text-xs md:text-sm text-gray-600 mt-1 md:mt-2" data-id="element-303">
                  Free Shipping
                </p>
              </div>
              <a href="https://tryayacaps.com/products/buy-3-aya-caps-get-3-free-ayahuasca-vine-microdoses-180-servings" className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white text-center font-bold py-2 md:py-4 px-2 md:px-4 rounded-lg transition duration-300 text-sm md:text-base" data-id="element-304">
                Get 6 Bottles Now
              </a>
              <div className="mt-2 md:mt-4 text-center" data-id="element-305">
                <span className="text-xs md:text-sm text-gray-600" data-id="element-306">
                  30-Day Money-Back Guarantee
                </span>
              </div>
            </div>
          </div>
          {/* Popular Card */}
          <div className="flex-1 min-w-[120px] md:min-w-[280px] bg-gradient-to-b from-white to-yellow-50 rounded-xl shadow-xl border border-yellow-200 overflow-hidden transition-transform duration-300 hover:shadow-2xl hover:-translate-y-1" data-id="element-307">
            <div className="bg-yellow-500 text-white text-center py-2 md:py-3 font-bold text-sm md:text-lg" data-id="element-308">
              MOST POPULAR
            </div>
            <div className="p-3 md:p-6" data-id="element-309">
              <h3 className="text-lg md:text-2xl font-bold text-center mb-1 md:mb-2" data-id="element-310">
                Buy 2, Get 1 Free
              </h3>
              <p className="text-sm md:text-lg text-center text-gray-600 mb-2 md:mb-6" data-id="element-311">
                3-Month Supply
              </p>
              <div className="flex justify-center mb-2 md:mb-6" data-id="element-312">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/484pPyp4CQSFfSw5uMncLW/Untitled_design_68.png" alt="3 bottles of Aya Caps" className="w-full max-w-[100px] md:max-w-[200px] h-auto" data-id="element-313" />
              </div>
              <div className="text-center mb-2 md:mb-6" data-id="element-314">
                <div className="flex justify-center items-center gap-1 md:gap-2 mb-0 md:mb-1" data-id="element-315">
                  <span className="text-sm md:text-xl line-through text-gray-500" data-id="element-316">
                    $147
                  </span>
                  <span className="text-xl md:text-3xl font-bold text-yellow-700" data-id="element-317">
                    $98
                  </span>
                </div>
                <p className="text-xs md:text-lg text-yellow-600 font-semibold" data-id="element-318">
                  Save 33% ($32.66/bottle)
                </p>
                <p className="text-xs md:text-sm text-gray-600 mt-1 md:mt-2" data-id="element-319">
                  Free Shipping
                </p>
              </div>
              <a href="https://tryayacaps.com/products/buy-2-aya-caps-get-1-free-ayahuasca-vine-microdoses-90-servings-total" className="block w-full bg-yellow-500 hover:bg-yellow-600 text-white text-center font-bold py-2 md:py-4 px-2 md:px-4 rounded-lg transition duration-300 text-sm md:text-base" data-id="element-320">
                Get 3 Bottles Now
              </a>
              <div className="mt-2 md:mt-4 text-center" data-id="element-321">
                <span className="text-xs md:text-sm text-gray-600" data-id="element-322">
                  30-Day Money-Back Guarantee
                </span>
              </div>
            </div>
          </div>
          {/* Basic Card */}
          <div className="flex-1 min-w-[120px] md:min-w-[280px] bg-gradient-to-b from-white to-gray-50 rounded-xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:shadow-2xl hover:-translate-y-1" data-id="element-323">
            <div className="bg-gray-600 text-white text-center py-2 md:py-3 font-bold text-sm md:text-lg" data-id="element-324">
              STARTER
            </div>
            <div className="p-3 md:p-6" data-id="element-325">
              <h3 className="text-lg md:text-2xl font-bold text-center mb-1 md:mb-2" data-id="element-326">
                1 Bottle
              </h3>
              <p className="text-sm md:text-lg text-center text-gray-600 mb-2 md:mb-6" data-id="element-327">
                1-Month Supply
              </p>
              <div className="flex justify-center mb-2 md:mb-6" data-id="element-328">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rQv5SZB4HKFJpLb9VvDpmB/1.png" alt="1 bottle of Aya Caps" className="w-full max-w-[100px] md:max-w-[200px] h-auto" data-id="element-329" />
              </div>
              <div className="text-center mb-2 md:mb-6" data-id="element-330">
                <span className="text-xl md:text-3xl font-bold text-gray-700" data-id="element-331">
                  $49
                </span>
                <p className="text-xs md:text-sm text-gray-600 mt-1 md:mt-2" data-id="element-332">
                  + Shipping
                </p>
              </div>
              <a href="https://tryayacaps.com/products/aya-caps-30-serving-bottle" className="block w-full bg-gray-600 hover:bg-gray-700 text-white text-center font-bold py-2 md:py-4 px-2 md:px-4 rounded-lg transition duration-300 text-sm md:text-base" data-id="element-333">
                Get 1 Bottle Now
              </a>
              <div className="mt-2 md:mt-4 text-center" data-id="element-334">
                <span className="text-xs md:text-sm text-gray-600" data-id="element-335">
                  30-Day Money-Back Guarantee
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}